import axios from "axios"
import {message} from "antd";
import {getConfig, getMappingUtil} from "./utility";

const initialState = {
    lovResult: [],
    lovTypes: [],
    lovLabel: [],
    lovTypesFetch: false,
    lovTypesSingle: false,
    lovTypesSingleFetch: false,
    lovLabelFetch: false,
    selectedCountry: null,
    selectedType: null,
    selectedCode: null,
    mappings: [],
    gettingMapping: false,
    globalLovs: {},
    localLovs: {},
    saving: false,
    loadingLovs: false
};

const MAPPING_GET = "MAPPING_GET";
const MAPPING_ADD = "MAPPING_ADD";
const MAPPING_REMOVE = "MAPPING_REMOVE";
const MAPPING_SAVE = "MAPPING_SAVE";
const LOVS_GET = "LOVS_GET";
const COUNTRY_SET = "COUNTRY_SET";
const TYPE_SET = "TYPE_SET";
const LOVTYPE_GET = "LOVTYPE_GET";
const LOVTYPE_DETAIL = "LOVTYPE_DETAIL";
const LOVLABEL_DETAIL = "LOVLABEL_DETAIL";
const SEARCHTYPE_SEARCH = "SEARCHTYPE_SEARCH";

export default (state = initialState, action) => {
    switch (action.type) {
        case MAPPING_GET:
            switch (action.status) {
                case 0:
                    return {...state, gettingMapping: true};
                case 1:
                    return {...state, gettingMapping: false, mappings: action.mappings, selectedCode: action.code};
                default:
                    return {...state, gettingMapping: false};
            }
        case COUNTRY_SET:
            return {...state, selectedCountry: action.country};
        case TYPE_SET:
            return {...state, selectedType: action.lovType};
        case MAPPING_ADD:
            const {lovType, codes} = action;
            const oldMappings = state.mappings.filter(lov => lov.type !== lovType);
            console.log(lovType, codes);
            const newLovs = state.globalLovs[lovType].filter(lov => codes.indexOf(lov.code) >= 0).map(lov => {
                lov.type = lovType;
                return lov
            });
            const newMappings = [...oldMappings, ...newLovs];

            return {...state, mappings: newMappings};
        case MAPPING_REMOVE:
            const {type, code} = action.lov;
            const filtered = state.mappings.filter(lov => !(lov.type === type && lov.code === code));
            return {...state, mappings: filtered};
        case MAPPING_SAVE:
            switch (action.status) {
                case 0:
                    return {...state, saving: true};
                case 1:
                    message.success('Mapping saved!');
                    return {...state, saving: false};
                default:
                    return {...state, saving: false};
            }
        case LOVS_GET:
            switch (action.status) {
                case 0:
                    return {...state, loadingLovs: true};
                case 1:
                    const {local, global} = action.lovs;
                    return {...state, loadingLovs: false, globalLovs: global, localLovs: local};
                default:
                    return {...state, loadingLovs: false};
            }

        case LOVTYPE_GET:
            switch (action.status) {
                case 0:
                    return {...state, lovTypesFetch: true};
                case 1:
                    return {...state, lovTypes: action.lovTypes, lovTypesFetch: false};
                default:
                    return {...state, lovTypesFetch: false};
            }
        case LOVTYPE_DETAIL:
            switch (action.status) {
                case 0:
                    return {...state, lovTypesSingle: true};
                case 1:
                    return {...state, lovResult: action.lovResult, lovTypesSingle: false};
                default:
                    return {...state, lovTypesSingle: false};
            }

        case SEARCHTYPE_SEARCH:
            switch (action.status) {
                case 0:
                    return {...state, lovLabelFetch: true};
                case 1:
                    console.log('lovLabel: ', action.lovLabel);

                    return {...state, lovLabel: action.lovLabel, lovTypesSingleFetch: false};
                default:
                    return {...state, lovLabelFetch: false}
            }
        case LOVLABEL_DETAIL:
            switch (action.status) {
                case 0:
                    return {...state, lovLabelFetch: true};
                case 1:
                    console.log('lovLabel_detail: ', action.lovLabel);
                    return {...state, lovLabel: action.lovLabel, lovLabelFetch: false};
                default:
                    return {...state, lovLabelFetch: false};
            }
        default:
            return state;
    }
}

const getMappingReq = code => ({type: MAPPING_GET, status: 0, code});
const getMappingSuc = (mappings, code) => ({type: MAPPING_GET, status: 1, mappings, code});
const getMappingErr = error => ({type: MAPPING_GET, status: -1, error});
export const getMapping = (code) => {
    return getMappingUtil(code, "lov", getMappingReq, getMappingSuc, getMappingErr);
};

const saveMappingReq = (mappingCompound) => ({type: MAPPING_SAVE, status: 0, mappingCompound});
const saveMappingSuc = () => ({type: MAPPING_SAVE, status: 1});
const saveMappingErr = error => ({type: MAPPING_SAVE, status: -1, error});
export const saveMapping = () => (dispatch, getState) => {
    const {selectedType, selectedCode, mappings} = getState().lov;
    const mappingCompound = {type: selectedType, code: selectedCode, mappings};
    dispatch(saveMappingReq(mappingCompound));
    axios.post(`/lov/mapping`, mappingCompound, getConfig(getState))
        .then(res => dispatch(saveMappingSuc()))
        .catch(err => dispatch(saveMappingErr(err)))
};

export const setCountry = (country) => ({type: COUNTRY_SET, country});
export const setType = (type) => ({type: TYPE_SET, lovType: type});
export const addMapping = (lovType, codes) => ({type: MAPPING_ADD, lovType, codes});
export const removeMapping = (lov) => ({type: MAPPING_REMOVE, lov});

const getLovsReq = () => ({type: LOVS_GET, status: 0});
const getLovsSuc = lovs => ({type: LOVS_GET, status: 1, lovs});
const getLovsErr = error => ({type: LOVS_GET, status: -1, error});
export const getLovs = () => (dispatch, getState) => {
    dispatch(getLovsReq());
    axios.get('/lov/mapping', getConfig(getState))
        .then(res => dispatch(getLovsSuc(res.data)))
        .catch(err => dispatch(getLovsErr(err)))
};

//Get Result Types
const getLovTypeResultsReq = () => ({type: LOVTYPE_GET, status: 0});
const getLovTypeResultsRec = lovTypes => ({type: LOVTYPE_GET, status: 1, lovTypes});
const getLovTypeResultsErr = error => ({type: LOVTYPE_GET, status: -1, error});
export const getLovTypeResults = () => (dispatch, getState) => {
    dispatch(getLovTypeResultsReq);
    return axios.get("/lovResult", getConfig(getState))
        .then(res => {
            console.log('LOV RESULT', res);
            return res;
        })
        .then(res => dispatch(getLovTypeResultsRec(res.data)))
        .catch(err => dispatch(getLovTypeResultsErr(err)))
};

const getLovResultReq = (id) => ({type: LOVTYPE_DETAIL, status: 0, id});
const getLovResultSuc = lovResult => ({type: LOVTYPE_DETAIL, status: 1, lovResult});
const getLovResultErr = error => ({type: LOVTYPE_DETAIL, status: -1, error});
export const getLovResult = (id, label) => (dispatch, getState) => {
    dispatch(getLovResultReq(id, label));
    return axios.get(`/lovResult/${id}/links`, getConfig(getState))
        .then(res => { console.log('LINK AFFILIATION', id); return res;})
        .then(res => dispatch(getLovResultSuc(res.data)))
        .catch(err => dispatch(getLovResultErr(err)))
};
const getLovLabelReq = (id) => ({type: LOVLABEL_DETAIL, status: 0, id});
const getLovLabelSuc = lovLabel => ({type: LOVLABEL_DETAIL, status: 1, lovLabel});
const getLovLabelErr = error => ({type: LOVLABEL_DETAIL, status: -1, error});
export const getLovLabel = (id) => (dispatch, getState) => {
    dispatch(getLovLabelReq(id));
    console.log('requesting', id);

    return axios.get(`/lovResult/${id}`, getConfig(getState))
        .then(res => dispatch(getLovLabelSuc(res.data)))
        .catch(err => dispatch(getLovLabelErr(err)))
};
const searchLovResultReq = request => ({type: SEARCHTYPE_SEARCH, status: 0, request});
const searchLovResultSuc = lovLabel => ({type: SEARCHTYPE_SEARCH, status: 1, lovLabel});
const searchLovResultErr = error => ({type: SEARCHTYPE_SEARCH, status: -1, error});
export const search = (request) => (dispatch, getState) => {
    dispatch(searchLovResultReq(request));
    return axios.post('/lovResult/search', request, getConfig(getState))
        .then(res => dispatch(searchLovResultSuc(res.data)))
        .catch(err => dispatch(searchLovResultErr(err)))
};



// WEBPACK FOOTER //
// ./src/js/reducers/lov.js